module.exports = __webpack_public_path__ + "img/talent_recruitment.6158117.webp";